import { ApolloLink } from '@common/hooks';
import Auth from 'works/legacy/lib/auth';

export const lastRequestTimeMiddleware = new ApolloLink(
  (operation, forward) => {
    writeLastRequestTime();
    return forward(operation);
  }
);

async function writeLastRequestTime() {
  if (!Auth.idleTimeoutDuration()) return;

  const isSignedIn = Auth.signedIn();
  const membershipId = Auth.membershipId();
  const isSessionExpired = Auth.isSessionExpired();

  if (isSignedIn && membershipId && !isSessionExpired) {
    Auth.update({ lastRequestTime: Date.now() });
  }
}
